module.exports = __webpack_public_path__ + "static/pinpai.94903776.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/partners/pinpai.jpg
// module id = 713
// module chunks = 168707334958949